import { render, staticRenderFns } from "./questionBox.vue?vue&type=template&id=47e3829d"
import script from "./questionBox.vue?vue&type=script&lang=js"
export * from "./questionBox.vue?vue&type=script&lang=js"
import style0 from "./questionBox.vue?vue&type=style&index=0&id=47e3829d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports